import React, { useEffect, useState } from "react";
import ExportModal from "./toolbar-extra/ExportModal";
import MultiCombobox from "../MultiCombobox";
import DateDropdown from "../DateDropdown";
import SearchInput from "../SearchInput";

const typeOptions = [
  {
    value: "form",
    label: "Form",
  },
  {
    value: "paths",
    label: "Paths",
  },
  {
    value: "walkthroughs",
    label: "Walkthroughs",
  },
];

const learningGroupOptions = [
  {
    value: "completed",
    label: "Completed",
  },
  {
    value: "in progress",
    label: "In Progress",
  },
];

function SatisfactionToolbar({ table }) {
  const [typeFilters, setTypeFilters] = useState([]);
  const [ratingFilters, setRatingFilters] = useState([]);

  useEffect(() => {
    const column = table.getColumn("type");
    if (typeFilters.length > 0) {
      column.setFilterValue(typeFilters);
    } else {
      column.setFilterValue(undefined);
    }
  }, [typeFilters, table]);

  useEffect(() => {
    const column = table.getColumn("rating");
    if (ratingFilters.length > 0) {
      column.setFilterValue(ratingFilters);
    } else {
      column.setFilterValue(undefined);
    }
  }, [ratingFilters, table]);

  return (
    <div className="avatar-model-toolbar">
      <SearchInput
        placeholder="Search Material"
        value={table.getColumn("materialName")?.getFilterValue() ?? ""}
        setValue={(value) =>
          table.getColumn("materialName").setFilterValue(value)
        }
      />
      <div className="toolbar-filter-section">
        <MultiCombobox
          options={typeOptions}
          filters={typeFilters}
          setFilters={setTypeFilters}
          placeholder="Type"
        />
        <MultiCombobox
          options={learningGroupOptions}
          filters={ratingFilters}
          setFilters={setRatingFilters}
          placeholder="Rating"
        />
      </div>
    </div>
  );
}

export default SatisfactionToolbar;
